import { reload_order_list_all } from "./OrderConn";
import { Fn_activeAxios } from "../function/FnConfig";
import { notifyReload } from "function/FnBodyStep";
import { fn_layerCstType, fn_ygyEndOrderCancel } from "function/FnBodyLayer";
import { MobileOrderFg } from "types";

// 매장 기본정보 조회
export async function fn_change_step_cd(rootStore, data) {
  let jsonData = JSON.parse(data);
  const api = Fn_activeAxios(rootStore);
  try {
    const res = await api.post("/gate/okgo/changeStep", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    });
    rootStore.viewStore.setDetailClose(); // 상세 닫기
    rootStore.layerStore.setLayerCstExpectTime(false); // 고객 예정시간 닫기
    rootStore.layerStore.setLayerOrderReject(false); // 주문거절 닫기
    rootStore.layerStore.setLayerOrderCancel(false); // 주문취소 닫기
    rootStore.layerStore.setLayerSoldOut(false); // 품절닫기
    rootStore.layerStore.setChangeCancelReason(""); // 거절 선택제거
    rootStore.viewStore.initCustomerPopBtn(); // 고객 선택 팝업 초기화
    rootStore.viewStore.initCustomerPopBtnYgy(); // 고객 선택 팝업 초기화
    rootStore.layerStore.setChangeCstTime(""); // 고객예상수령시간 초기화
    rootStore.viewStore.setNoShowCheck(false); // 매장식사 노쇼처리 초기화
    rootStore.orderStore.setCompletedCancel(false); // 완료주문내취소처리 초기화
    if (res && res.status === 200) {
      //요기요api 완료주문 취소시
      if (jsonData.stepCd == 900 && jsonData.mobileOrderFg == "27" && rootStore.viewStore.getOrderEndView) {
        fn_ygyEndOrderCancel(rootStore, jsonData, res.data.resultCode);
      }
      if (res.data.resultCode === "000") {
        reload_order_list_all(rootStore);

        if (rootStore.layerStore.getLayerAlertType) {
          rootStore.layerStore.setLayerAlertView(true);
        }
        return res.data.resultCode;
      } else {
        rootStore.layerStore.setAlertCustomTitle("주문상태변경 실패");
        //요기요 에러로직 추가
        if (res.data.resultCode === "YG0013") {
          rootStore.layerStore.setAlertCustomMessage("픽업예상시간 기준 60분 이내로만 호출가능합니다");
        } else if (res.data.resultCode === "SV2031") {
          rootStore.layerStore.setAlertCustomMessage("당일 건만 취소 가능합니다. 고객센터로 문의 해주세요.");
        } else if (res.data.resultCode === "DY0001") {
          rootStore.layerStore.setAlertCustomMessage("땡배달 픽업 이후 주문 취소할 수 없습니다.\n땡겨요 고객센터에 문의해 주세요");
        } else {
          rootStore.layerStore.setAlertCustomMessage(res.data.resultCode);
        }
        rootStore.layerStore.setLayerAlertType("alert_custom");
        rootStore.layerStore.setLayerAlertView(true);
      }
    } else {
      rootStore.layerStore.setAlertCustomTitle("주문상태변경 실패");
      rootStore.layerStore.setAlertCustomMessage(res.data.resultCode);
      rootStore.layerStore.setLayerAlertType("alert_custom");
      rootStore.layerStore.setLayerAlertView(true);
    }
  } catch (error) {
    if (jsonData.stepCd == 900 && jsonData.mobileOrderFg == "27" && rootStore.viewStore.getOrderEndView) {
      fn_ygyEndOrderCancel(rootStore, error);
    } else {
      rootStore.layerStore.setLayerAlertType("fail");
      rootStore.layerStore.setLayerAlertView(true);
    }
  }
  // 레이어닫기
}

// 요기요 자동취소 주문 판단
export async function ygy_auto_cancel(rootStore, mobileOrderNo, mobileOrderFg, type, min) {
  rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, mobileOrderNo);
  let data = JSON.stringify({
    mobileOrderNo: mobileOrderNo,
    shopCd: rootStore.searchStore.getShopCd,
  });
  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/yogiyo/autocancel", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.isAutoCancelOrder) {
          //fn_change_step(rootStore, '200');
        } else {
          fn_layerCstType(rootStore, mobileOrderNo, mobileOrderFg);
        }
      }
    })
    .catch(err => {});
}

// 조리완료
export async function fn_cooking_complete(rootStore, order) {
  rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, order.mobileOrderNo);
  const getPartnerCode = () => {
    if (
      order.mobileOrderFg === MobileOrderFg.HUNGRY_PANDA ||
      order.mobileOrderFg === MobileOrderFg.PANDA_SELF_DELIVERY
    ) {
      return "hungry-panda";
    }
    if (order.mobileOrderFg === MobileOrderFg.YOGIYO_EXPRESS) {
      return "yogiyo";
    }
    if (order.mobileOrderFg === MobileOrderFg.OLTTEA_AH) {
      return "oltteaah";
    }
  };
  const data = JSON.stringify({
    mobileOrderFg: order.mobileOrderFg,
    mobileOrderNo: order.mobileOrderNo,
    shopCd: rootStore.searchStore.getShopCd,
  });

  const patnerCode = getPartnerCode();
  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/agency/" + patnerCode + "/cooking/complete", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          rootStore.settingStore.setPosNotifySound("default");
          notifyReload(rootStore, order, "조리완료 알림을 전송했습니다");
        } else {
          rootStore.layerStore.setLayerAlertType("cooking_complete_fail");
          rootStore.layerStore.setLayerAlertView(true);
        }
      }
    })
    .catch(err => {});
}
